// jp.js
export const locale = {
  // default resource
  vue_form_generator_resources: {
    fieldIsRequired: "必須項目です",
    invalidFormat: "ルールに従って記入してください",

    numberTooSmall: "数値が小さすぎます 最小: {0}",
    numberTooBig: "数値が大きすぎます 最大: {0}",
    invalidNumber: "不適切な数値です",
    invalidInteger: "整数ではありません",

    textTooSmall: "文字数が短すぎます 現在: {0}, 最小値: {1}",
    textTooBig: "文字数が長すぎます 現在: {0}, 最大値: {1}",
    thisNotText: "文字列ではありません",

    thisNotArray: "配列ではありません",

    selectMinItems: "最小のアイテム選択 最小アイテム {0} 選択",
    selectMaxItems: "最大のアイテム選択 最大アイテム {0} 選択",

    invalidDate: "不適切な日付です!",
    dateIsEarly: "早すぎる日付です 現在: {0}, 最小値: {1}",
    dateIsLate: "遅すぎる日付です 現在: {0}, 最大値: {1}",

    invalidEmail: "不適切なEメールアドレスです",
    invalidURL: "不適切なURLです",

    invalidCard: "カードフォーマットが正しくありません",
    invalidCardNumber: "カード番号に誤りがあります",

    invalidTextContainNumber: "不適切な文字です。数字や記号などを入力することはできません",
    invalidTextContainSpec: "不適切な文字です。記号などの特殊文字を入力することはできません"
  },

  // ========================= base from =========================
  form_title: {
    normal: 'SenseLink Cloud<br />ログインアカウントを登録する',
    complete: 'この度はご登録いただき<br />ありがとうございます'
  },
  form_product_postfix: {
    normal: '',
    complete: 'SenseLinkにログイン'
  },
  footer_title: {
    normal: ['SenseLink Cloudに接続する', '登録'],
    complete: ['SenseLink Cloudへようこそ', '']
  },
  phone_hint: '「SMSに対応していない電話番号」を記載した場合、2段階認証の利用は不可となります。ご注意ください。',
  form: {
    license_group: {
      label: '登録済みの契約情報を確認してください。',
      confirm_label: '以下の情報で正しいか確認してください。正しければ「登録」をクリックしてください。違っていれば「やり直す」をクリックして正しい情報に修正してください。',
    },
    license_id: {
      label: 'アクティベーションコードを入力してください',
      placeholder: '',
      hint: '例：12345678-9abcdef1-23456789-abcdef12',
    },
    license_product: {
      label: '契約サービス',
      placeholder: '',
      hint: '',
    },
    license_plan: {
      label: '契約プラン',
      placeholder: '',
      hint: '',
    },
    license_term: {
      label: '契約期間',
      placeholder: '',
      hint: '',
    },
    login_group: {
      label: 'SenseLink Cloudのアカウントを作成するために、以下の情報を入力してください。',
      confirm_label: ''
    },
    login_account: {
      label: 'ログインアカウント',
      placeholder: '',
      hint: 'アカウントの文字数は6〜25字以内で、半角の英数字とアンダースコアのみを使ってください',
    },
    login_password: {
      label: 'パスワード',
      placeholder: '',
      hint: 'パスワードの文字数は8〜20文字以内で、大文字、小文字、数字、指定記号(~!@#$^*_+)をそれぞれ1つずつ含めてください',
    },
    login_confirm_password: {
      label:'パスワードの確認',
      placeholder:'',
      hint: '',
    },
    display_group: {
      label: '登録済みの契約情報を確認してください',
    },
    display_company: {
      label:'会社名',
      placeholder:'',
      hint: '例：日本コンピュータビジョン株式会社',
    },
    display_username: {
      label:'ユーザー名',
      placeholder:'',
      hint: '',
    },
    display_phone: {
      label:'電話番号',
      placeholder:'',
      hint: '例：080-1234-5678',
    },
    display_email: {
      label:'Eメールアドレス',
      placeholder:'',
      hint: '例：user@japancv.co.jp<br />・半角英数字、-._@+（半角）の6～45文字で、XX@XX.XX.XX または XX@XX.XXXの形式のみ登録可能です<br />・記載したメールアドレスにはSenseLinkCloudに関するご案内も送付されます'
    }
  },

  // ========================= direct from =========================
  direct_form: {
    form_title: {
      normal: 'JCVシリーズ ユーザ登録フォーム',
      complete: 'この度はご登録いただき<br />ありがとうございます'
    },
    form_product_postfix: {
      normal: '',
      complete: 'SenseLinkにログイン'
    },
    form_footer_title: {
      normal: ['SenseLink Cloudに接続する', '登録'],
      complete: ['SenseLink Cloudへようこそ', '']
    },
    form: {
      license_group: {
        label: '製品・サービス情報',
      },
      license_id: {
        label: 'アクティベーションコードを入力してください',
        placeholder: '',
        hint: '例：12345678-9abcdef1-23456789-abcdef12',
      },
      license_product: {
        label: '契約サービス',
        placeholder: '',
        hint: '',
      },
      license_plan: {
        label: '契約プラン',
        placeholder: '',
        hint: '',
      },
      license_term: {
        label: 'ライセンス有効期間',
        placeholder: '',
        hint: '契約日は登録日から登録日の1年後の日を含む月の最終日までです。Thunder Subscription をご購入のお客様は、月単位のご契約になりますので、上記のライセンス有効期間と異なります。',
      },
      user_group: {
        label: 'ご購入者様',
      },
      login_account: {
        label: 'SenseLink Cloudログインアカウント',
        placeholder: '',
        hint: 'アカウントの文字数は6〜25字以内で、半角の英数字とアンダースコアのみを使ってください',
      },
      login_password: {
        label: 'SenseLink Cloudログインパスワード',
        placeholder: '',
        hint: 'パスワードの文字数は8〜20文字以内で、大文字、小文字、数字、指定記号(~!@#$^*_+)をそれぞれ1つずつ含めてください',
      },
      login_confirm_password: {
        label:'パスワードの確認',
        placeholder:'',
        hint: '',
      },
      display_company: {
        label: '会社名　※個人の場合は個人と記入',
        placeholder:'',
        hint: '例：日本コンピュータビジョン株式会社',
      },
      display_lastname: {
        label: '姓',
        placeholder:'',
        hint: '例：山田',
      },
      display_firstname: {
        label: '名',
        placeholder:'',
        hint: '例：太郎',
      },
      display_phone: {
        label: '電話番号',
        placeholder:'',
        hint: '例：080-1234-5678',
      },
      display_zipcode: {
        label: '郵便番号',
        placeholder:'',
        hint: '例：1000001'
      },
      display_address: {
        label: '住所',
        placeholder:'',
        hint: '例：東京都千代田区麴町2-5-1WeWork 半蔵門 PREX South 6F'
      },
      display_email: {
        label: 'メールアドレス',
        placeholder:'',
        hint: '例：user@japancv.co.jp',
      }
    }
  },
  // ==================================================

  validate_form: {
    validation_group: {
      label: '登録したメールアドレスに送信された認証コードを入力してください',
      hint_label: '* 1度目の認証コード取得から60秒後に再取得ができます。'
    },
    otp_code: {
      label: '<span style="font-size: 1.00rem;">10分以内<span style="color: black;">に入力ください</span></span>',
      placeholder: '',
      hint: '',
      button_labels: [''],
    }
  },
  agreement_form: {
    title: 'ご同意事項',
    description: 'ご購入製品・サービスの「<a href="https://pardma.japancv.co.jp/jcv_terms_v1.1.pdf" target="_blank">使用許諾契約書</a>」「<a href="https://pardma.japancv.co.jp/jcv_terms_support_v1.3.pdf" target="_blank">サポートサービス規約</a>」「<a href="https://pardma.japancv.co.jp/jcv_terms_cloud_v1.0.pdf" target="_blank">JCVシリーズCloudサービス利用規約</a>」「<a href="https://pardma.japancv.co.jp/jcv_terms_rental_v1.0" target="_blank">使用許諾契約書（JCVレンタル向け）</a>」（適用ある場合）「<a href="https://pardma.japancv.co.jp/jcv_termsofuse_rental_v1.0" target="_blank">JCVシリーズレンタルサービス利用規約</a>」（適用ある場合）に記載の内容及びこれらがご購入者様と当社の契約内容となることに同意し、ユーザー登録を申請致します。なお、ご購入者様は、本登録情報が当社及び販売代理店に共有されることを承諾します。',
    checkbox: '上記事項に同意します。',
  },
  field: {
    warning: {
      mismatch_password: "パスワードが一致しません",
    }
  },
  button: {
    title: {
      validation: '次へ',
      confirm: '確認',
      submit: '登録',
      apply: '確認',
      cancel: 'キャンセル',
      modify: 'やり直す',
      otp_request: '認証コード取得',
      otp_resend: '認証コード再取得（%ss）',
    }
  },
  modal: {
    validation: {
      title: '認証コードを入力',
      hint: '認証コードが届かない場合は、<br />右のボタンで認証コードを再取得してください'
    },
  },
  toast: {
    title: {
      warning: '警告',
      confirm: '確認',
      submit: '登録',
      apply: '確認',
      cancel: 'キャンセル',
      modify: 'やり直す',
    },
    msg: {
      invalid_code: 'アクティベーションコードが正しくありません',
      valid_code: 'アクティベーションコードが正しくありません',
      inavailable_account: 'このアカウントは利用できません',
      available_account: '利用可能なアカウントです',
      invalid_phone: '電話番号が正しくありません',
      valid_phone: '有効な電話番号です',
      invalid_otp: '認証コードが無効です',
      valid_otp: '認証コードは有効です',
      confirm: '入力した内容を再確認してください',
      success: 'ご登録いただき、ありがとうございます',
      failure: 'ネットワークに不具合が発生しました。しばらく経ってから再入力してください'
    }
  }
}
